// src/utils/confetti.ts - Реальное конфетти вместо несуществующего Telegram API

import confetti from 'canvas-confetti';

/**
 * ⚠️ ВАЖНО: Telegram WebApp API НЕ имеет метода showConfetti()!
 * Используем canvas-confetti для реального эффекта.
 */

/**
 * 🎉 Конфетти для открытия достижения
 */
export const celebrateAchievement = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors:['#7B68EE', '#9966CC', '#87CEEB', '#34D399'],
    zIndex: 10000,
  });
};

/**
 * 🎊 Конфетти для перехода на новый этап (3 секунды с боков)
 */
export const celebrateStageUpgrade = () => {
  const duration = 3000;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors:['#22C55E', '#10B981'],
      zIndex: 10000,
    });
    
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors:['#22C55E', '#10B981'],
      zIndex: 10000,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  
  frame();
};